import React from 'react';
import { Box, Button, Center, Icon, Text, VStack } from '@chakra-ui/react';
import { ReportingViewBaseConfig } from '../../../base';
import { DocumentNewViewProps } from './documentNewProps';
import { HiOutlineDocumentText } from 'react-icons/hi';

export function createDocumentNewView(
    config: ReportingViewBaseConfig
): React.FC<DocumentNewViewProps> {
    const {
        UI: {
            Application: { Link },
        },
    } = config;

    return function DocumentNewView(props: DocumentNewViewProps) {
        return (
            <VStack w="full" align="start" px={6}>
                <VStack
                    w="full"
                    align="center"
                    pt={{ base: 2, md: 3, lg: 4, xl: 6 }}
                    pb={{ base: 24, xl: 44 }}
                    spacing={{ base: 4, md: 6, lg: 8, xl: 12 }}
                >
                    <Center h="60vh" w="100%">
                        <VStack spacing={8} textAlign="center" maxW="480px">
                            <VStack spacing={6}>
                                <Box
                                    fontSize="3xl"
                                    width={12}
                                    height={12}
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    borderRadius="lg"
                                    bg="whiteAlpha.50"
                                    border="2px dashed"
                                    borderColor="whiteAlpha.200"
                                >
                                    <Icon
                                        as={HiOutlineDocumentText}
                                        fontSize="2xl"
                                        color="whiteAlpha.300"
                                    />
                                </Box>
                                <VStack spacing={2}>
                                    <Text
                                        fontSize="lg"
                                        fontWeight="medium"
                                        color="whiteAlpha.500"
                                    >
                                        No document selected
                                    </Text>
                                    <Text
                                        fontSize="sm"
                                        color="whiteAlpha.400"
                                        lineHeight="1.5"
                                        maxW="24rem"
                                    >
                                        Create a new document or select an existing one
                                        from the sidebar to get started with your
                                        research.
                                    </Text>
                                </VStack>
                            </VStack>
                        </VStack>
                    </Center>
                </VStack>
            </VStack>
        );
    };
}
